module.exports = __webpack_public_path__ + "img/partner_icon15.31d8e52a.png";